/*
 * @Author: 杨伟豪 yangweihao@ucanit.cn
 * @Date: 2023-02-09 14:44:08
 * @LastEditors: 杨伟豪 yangweihao@ucanit.cn
 * @LastEditTime: 2023-02-09 14:44:33
 * @FilePath: \hp-njroad-wechat\src\api\weeklyMenu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

// 每周菜单列表
export function selectMenuList(params) {
  return request({
    url: "/wechat/bizWeixinActivitySignInfo/selectMenuList",
    method: "get",
    params
  });
}

// 活动报名接口
export function applySignInfo(data) {
  return request({
    url: "/wechat/bizWeixinActivitySignInfo",
    method: "post",
    data
  });
}

// 列表
export function foodMenuManage(data) {
  return request({
    url: "wechat/bizWeixinActivitySignInfo/foodMenuManage",
    method: "get",
    params:data
  });
}

